<template>
    <div class="team-page">
        <div class="top-menu">
            <div class="top">人工智能与机器视觉实验室</div>
            <div class="blank"></div>
            <div class="menu">
                <div class="menu-detail" @click="jumpToHome">首页</div>
                <div class="menu-detail" @click="jumpToTutor">导师风采</div>
                <div class="menu-detail" @click="jumpToTeam">科研团队</div>
                <div class="menu-detail" @click="jumpToPaper">论文成果</div>
                <div class="menu-detail" @click="jumpToHonor">获奖情况</div>
                <div class="menu-detail" @click="jumpToDownload">文件下载</div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInnovation"> Innovation </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToService"> Service </div>
                <div class="menu-detail" style="font-family: 'Times New Roman', Times, serif;" @click="jumpToInfluence_Contribution"> Influence and Contribution </div>
            </div>
        </div>

        <div class="blank"></div>
        <div class="page-content">
            <div class="paper-block">
                <div class="paper-block-title" @click="jumpToInnovation">Organize Special Issues</div>
                <div class="paper-block-word">
                    <div class="paper-block-word-item">
                        [1] Remote Sensing (Guest Editor), 2023.01-2023.12,
                        This special issue is published with a total of 11 papers, thus obtaining the second edition
                        special issue “Explainable Deep Neural Networks for Remote Sensing Image Understanding II” 
                        <a href="https://www.mdpi.com/journal/remotesensing/special_issues/3L86N93K48" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [2] Mathematics (Guest Editor), 2022.2-2023.12,
                       "Computational Intelligence in Image Processing and Pattern Recognition"
                        <a href="https://www.mdpi.com/journal/mathematics/special_issues/Intelligence_Image_Processing_Pattern_Recognition" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [3] Applied Sciences (Guest Editor), 2022.1-2022.8,
                       "Deep Learning for Facial Expression Analysis"
                        <a href="https://www.mdpi.com/journal/applsci/special_issues/Facial_Expression_Analysis" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [4] Frontiers in Signal Processing, Associate Editor, 2021.03-2023.03,
                       "Recent Advances in Image and Video Semantic Segmentation Using Deep Learning"
                        <a href="https://www.frontiersin.org/research-topics/22286/recent-advances-in-image-and-video-semantic-segmentation-using-deep-learning" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [5] Remote Sensing (Guest Editor), 2019.11-2020.12,
                        “Lightweight Deep Neural Networks for Remote Sensing Image Understanding”
                        <a href="https://www.mdpi.com/journal/remotesensing/special_issues/Lightweight_DNN" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [6] Remote Sensing (Guest Editor), 2021.01-2021.12,
                        “Explainable Deep Neural Networks for Remote Sensing Image Understanding”
                        <a href="https://www.mdpi.com/journal/remotesensing/special_issues/DeepNeuralNetworks" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [7] IEEE J. Sel. Top. Appl. Earth Obs. Remote Sens. (Guest Editor), 2021.5-2021.12,
                        “Intelligent perception of geohazards from earth observations and remote sensing”
                        <a href="http://www.grss-ieee.org/wpcontent/uploads/2021/02/JSTARS_CFP_Intelligent_perception_of_geohazards_from_EOs_and_RS.pdf" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                </div>
             </div>
        </div>

            <div class="paper-block">
                <div class="paper-block-title" @click="jumpToInnovation">Selected Chairs at International Conference</div>
                    <div class="paper-block-word">

                    <div class="paper-block-word-item">
                        [1] The 6th International Conference on Computer Vision and Pattern Analysis (ICCPA 2024), 
                        <span style="font-weight: bold; color:blue;">Technical Program Committee Chair</span>,  
                        2024.5.17-19.
                        <a href=" https://www.iccpa.org/" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [2] The 4th International Conference on Video, Signal and Image Processing (VSIP 2024), 
                        <span style="font-weight: bold; color:blue;">Program Chair</span>,
                        2024.11.22-24.
                        <a href=" https://vsip.net/" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [3] The 6th International Conference on Information Science, Electrical and Automation Engineering (ISEAE 2024),
                        <span style="font-weight: bold; color:blue;">Publication Chair</span>,
                        2024.04.19-21.
                        <a href="http://iseae.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [4] The 5th International Conference on Video, Signal and Image Processing (VSIP 2023),
                        <span style="font-weight: bold; color:blue;">Program Chair and Session Chair</span>,
                        2023.11.24-26.
                        <a href=" https://vsip.net/" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [5] The 4th International Symposium on Computer Engineering and Intelligent Communications (ISCEIC 2023),
                        <span style="font-weight: bold; color:blue;">Publication Chair</span>,
                        2023.08.18-20.
                        <a href="http://iseic.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [6] The 5th International Conference on Information Science, Electrical and Automation Engineering (ISEAE 2023),
                        <span style="font-weight: bold; color:blue;">Publication Chair</span>,
                        2023.03.24-26.
                        <a href="http://iseae.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [7] The 2nd International Symposium on Computer Applications and Information Systems (ISCAIS 2023),
                        <span style="font-weight: bold; color:blue;">Technical Program Committee chair</span>,
                        2023.03.24-26.
                        <a href="http://iscais.com" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [8] The 2nd International Conference on Electronic Information Engineering and Computer Communication (EIECC2022),
                        <span style="font-weight: bold; color:blue;">Technical Program Committee Chair</span>,
                        2022.11.25-27.
                        <a href="http://eiecc.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [9] The 5th International Conference on Image and Graphics Processing (ICIGP 2022),
                        <span style="font-weight: bold; color:blue;">Award Chair</span>,
                        2022.1.7-2022.1.9.
                        <a href="www.icigp.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [10] The 3rd International Symposium on Computer Engineering and Intelligent Communications (ISCEIC 2022),
                        <span style="font-weight: bold; color:blue;">Technical Program Committee chair</span>,
                        2022.9.16-2022.9.18.
                        <a href="http://isceic.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [11] The 4th International Conference on Image and Graphics Processing (ICIGP 2021),
                        <span style="font-weight: bold; color:blue;">Publicity Chair</span>.
                        <a href="www.icigp.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [12] The 16th International Conference on Natural Computation, Fuzzy Systems and Knowledge Discovery (ICNC-FSKD 2020),
                        <span style="font-weight: bold; color:blue;">General Chair</span>,
                        2020.12.19-2020.12.21.
                        </div>
                    
                </div>
            </div>
            
            <div class="paper-block">
                <div class="paper-block-title">Selected Keynote Speakers</div>
                <div class="paper-block-word">

                    <div class="paper-block-word-item">
                        [1] 2024 4th International Conference on Computer Graphics, Artificial Intelligence and Data Processing (ICCAID 2024)
                        <span style="font-weight: bold; color:blue;">Keynote Speaker</span>,
                        “Remote Sensing Image Change Detection Using Lightweight Deep Network Models”, 2024,11.29-2024.12.1, Harbin.
                        <a href="http://www.iccaid.net/" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [2] 2024 4th International Conference on Optics and Image Processing (ICOIP 2024),
                        <span style="font-weight: bold; color:blue;">Keynote Speaker</span>,
                        “Consistency Learning for Semi-supervised Image Segmentation”, 2024,05.15-17, Changchun.
                        <a href="http://icoip.net/" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [3]	The 6th International Conference on Information Science, Electrical and Automation Engineering (ISEAE 2024),
                        <span style="font-weight: bold; color:blue;">Keynote Speaker</span>,
                        “Semi-supervised Learning for Medical Image Segmentation”, 2024,04.19-21, Wuhan.
                        <a href="http://iseae.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [4]	2023 4th International Conference on Computer Science and Management Technology (ICCSMT),
                        <span style="font-weight: bold; color:blue;">Keynote Speaker</span>,
                        “Medical Image Segmentation under Constrained Conditions”, 2023,10.13-15, Xi’an.
                        <a href="http://www.iccsmt.net/Speakers" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    <div class="paper-block-word-item">
                        [5]	The 2rd International Conference on Electronic Information Engineering and Computer Communication (EIECC2022),
                        <span style="font-weight: bold; color:blue;">Keynote Speaker</span>,
                        “Lightweight Networks for Abdominal Image Segmentation,” 2022.11.25-27, Xi’an.
                        <a href="http://eiecc.org" target="_blank" style="user-select: auto;"><span style="font-family: Arial; font-size: 16px; user-select: auto;">[Link]</span></a>
                        </div>
                    </div>
            </div>
        <div>
    </div>
             <div class="footer">Copyright© 2019 All Rights Reserved. 陕西科技大学人工智能与机器视觉实验室版权所有  </div>
    </div>
</template>

<script>
    export default {
    data() {
        return {
            path: process.env.BASE_URL,
            CiT_Net: "../download/CiT_Net.pdf",
            Def_Net: "../download/DefED-net.pdf",
            TCDS: "../download/TCDS.pdf",
            USSFC: "../download/Ultralightweight_SpatialSpectral_Feature.pdf",
            landslide: "../download/Landslide.pdf",
            DESSN: "../download/DESSN.pdf",
            ASENet: "../download/ASENet.pdf",
            SDC_SSL: "../download/SDC-SSL.pdf",
            AFCF: "../download/AFCF.pdf",
            SGUNet: "../download/SGUNet.pdf",
            AMRR: "../download/AMRR.pdf",
            medicalsurvey: "../download/Medical-image-segmentation-survey.pdf",
            SFFCM: "../download/SFFCM.pdf",
            FRFCM: "../download/FRFCM.pdf",
            SE_MGMM: "../download/SE-MGMM.pdf",
            a_conditionally_invariant_mathematical_morphological: "../download/a conditionally invariant mathematical morphological.pdf",
            research_progress_on_image_segmentation_based_on_fuzzy_clustering: "../download/research progress on image segmentation based on fuzzy clustering.pdf",
            Grain_segmentation_of_ceramic_materials: "../download/Grain segmentation of ceramic materials.pdf",
            FRSC: "../download/FRSC.pdf",
        };
    },
        methods: {

            jumpToHome() {
                this.$router.push({
                    name: "home",
                });
            },
            jumpToTutor() {
                this.$router.push({
                    name: "tutor",
                });
            },
            jumpToTeam() {
                this.$router.push({
                    name: "team",
                });
            },
            jumpToPaper() {
                this.$router.push({
                    name: "paper",
                });
            },
            jumpToHonor() {
                this.$router.push({
                    name: "honor",
                });
            },
            jumpToDownload() {
                this.$router.push({
                    name: "download",
                });
            },
            jumpToInnovation() {
                this.$router.push({
                    name: "innovation",
                });
            },
            jumpToService() {
                this.$router.push({
                    name: "service",
                });
            },
            jumpToInfluence_Contribution() {
                this.$router.push({
                    name: "influence_contribution",
                });
            },
        },
    };
</script>

<style scoped>
    .tutor-page {
        width: 100%;
        height: 100%;
        background-color: #fffef9;
        display: flex;
        flex-direction: column;
    }

    .top-menu {
        width: 100%;
    }

  .top {
      height: 12vh;
      width: 100%;
      background-image: url("../../assets/bg.jpg");
      color: white;
      font-size: 2.1vmax;
      font-weight: 500;
      line-height: 12vh;
      text-align: center;
      letter-spacing: 1vmax;
  }

  .menu {
      display: flex;
      flex-direction: row;
      height: 5vh;
      font-size: 1.1vmax;
      line-height: 5vh;
      padding-left: 3.1vmax;
      background-color: #dfe8ed;
  }

  .menu-detail {
    padding: 0 0.5vmax;
    cursor: pointer;
  }

  .blank {
    background-color: #dfe8ed;
    height: 3px;
    width: 100%;
  }


    .menu-detail:hover {
        background-color: #dfe8ed;
    }

    .page-content {
        width: 100%;
    }

    .paper-block {
        border: 1px solid #517b95;
        margin: 10px 100px;
    }

    .paper-block-title {
        background-color: #7494b1;
        color: #ffffff;
        font-size: 18px;
        height: 30px;
        line-height: 30px;
        padding-left: 20px;
        letter-spacing: 3px;
    }

    .paper-block-word {
        line-height: 28px;
        padding-left: 20px;
        font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
        font-size: 18px;
    }

    .paper-block-word-item {
        padding-bottom: 10px;
    }

    .icon-yuandianzhong {
        color: #8a9098;
    }
    .footer{
        height: 70px;
        background-color: 	#575D64;
        color: #ffffff;
        line-height: 70px;
        text-align: center;
        margin-top: 30px;
    }
</style>>